// extracted by mini-css-extract-plugin
export default {"headMenuItem":"CategoryMenuItem_headMenuItem__5oYwY","active":"CategoryMenuItem_active__wtFip"};